import PropTypes from 'prop-types'
import React from 'react'

import styles from './buttonClose.module.scss'

const ButtonClose = ({ className = '', colorClass = '', ...rest }) => {
  return (
    <button className={`${styles.buttonClose} ${className}`} {...rest}>
      <div className={`${styles.mdiv} ${colorClass}`}>
        <div className={`${styles.md} ${colorClass}`}></div>
      </div>
    </button>
  )
}

ButtonClose.propTypes = {
  className: PropTypes.string,
  colorClass: PropTypes.string, // define background color
}

export { ButtonClose }
